import Vue from 'vue';
/**
 * This handles displaying generic alerts/toasts to the user.
 *
 * Expected use:
 *
 * import alertSvc from '@/services/alertSvc.js';
 * ...
 * alertSvc.error('test alert');
 * alertSvc.success('test alert');
 * ...
 */
export default {
  showAlert,
  success,
  error,
  networkError,
  onAlert
};
/**
 * The "bus" is used to do the actual event alerting. This is consumed by TheAlert
 */
const bus = new Vue();
/**
 * This is the default amount of time before an alert will disappear
 */
const defaultTimeout = 5000;
/**
 * Add a hook for when new alerts come in. This expects a fn that will accept an alert and do something with it
 */
function onAlert(fn) {
  bus.$on('alert', fn);
}
/**
 * Alert the user to a generic networking error. This could be any type of unexpected error that occurred
 */
function networkError(errorData) {
  error('A networking error occurred - check your network connection and try again or contact customer support');
}
/**
 * Show an error message to the user with the given message
 */
function error(message) {
  showAlert({
    message: message,
    type: 'error',
    timeout: defaultTimeout
  });
}
/**
 * Show a success message to a user
 */
function success(message) {
  showAlert({
    message: message,
    type: 'success',
    timeout: defaultTimeout
  });
}
/**
 * Show an alert to the user. The alert object should be of the form:
 * {
 *   message: 'Some messages',
 *   type: 'success',
 *   timeout: 1234,
 * }
 */
function showAlert(alert) {
  bus.$emit('alert', alert);
}
